module.exports = __webpack_public_path__ + "static/media/other-optioned-building-black.cc092176.svg";